import { MDBCol } from "mdbreact";
import React, { Component } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import Notiflix from "notiflix";
import PostApiCall from "../../Api";

import "react-confirm-alert/src/react-confirm-alert.css";

import "react-responsive-modal/styles.css";

import Searchicon from '../../assets/images/dashboardimages/search.png';


import Saveicon from '../../assets/images/dashboardimages/filesave.png';
import Editicon from '../../assets/images/dashboardimages/pencil.png';


const ImgUpload = ({ onChange, src }) => (
  <label htmlFor="photo-upload" className="custom-file-upload fas" style={{ marginBottom: '5px' }}>
    <div className="img-wrap brandimages img-upload">
      <img
        for="photo-upload"
        src={src}
        style={{ width: "100%", height: "100%", borderRadius: "5%" }}
      />
    </div>
    <input accept="image/*" id="photo-upload" type="file" onChange={onChange} />
  </label>
);

class StickerSizeMaster extends Component {
  constructor(props) {
    super(props);
    const { shapeIdProps } = props.match.params;
    this.state = {
      data: [],
      searchInput: "",
      stickerSizeData: [],
      ViewClick: "true",
      open: false,
      imagePreviewUrl: 'https://icons.iconarchive.com/icons/pelfusion/flat-folder/256/Upload-Folder-icon.png',
      ImageApiUrl: JSON.parse(localStorage.getItem("ClientDetails"))[0].fld_apiaddress + "AddImage",
      Status: "Yes",
      SizeName: "",
      originalImage: null,
      outputFileName: null,
      openedit: false,
      stickerSizeId: null,
      length: null,
      width: null,
      shapeid: shapeIdProps,
      shapeName: null,
      sequence: null
    };
  }

  componentDidMount() {
    Notiflix.Loading.Init({
      svgColor: "#777f80",
      // ...
    });

    // Fetch Sticker Size data from the API
    PostApiCall.postRequest(
      {
        WhereClause: `where fld_shape_id = ${this.state.shapeid}`,
      },
      "GetStickerSizeMaster"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status === 200 || result.status === 201) {
          this.setState({
            stickerSizeData: obj.data,
            shapeName: obj.data[0]?.shape_name
          });
          Notiflix.Loading.Remove();
        }
      })
    );
  }

  // name is mandatory
  onSaveData() {
    if (this.state.fld_length !== "") {
      if (this.state.fld_width !== "") {
        this.onPost();
      } else {
        Notiflix.Notify.Failure("Please enter Sticker Width.");
      }
    } else {
      Notiflix.Notify.Failure("Please enter Sticker Length.");
    }
  }

  onPost = () => {
    Notiflix.Loading.Dots("Please wait...");

    var login = localStorage.getItem("LoginDetail");
    var details = JSON.parse(login);

    PostApiCall.postRequest(
      {
        fld_id: this.state.stickerSizeId, // ID with response
        width: this.state.width,
        status: this.state.Status,
        length: this.state.length,
        shapeid: this.state.shapeid,
        sequence: this.state.sequence
      },
      "AddSizeMaster"
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status === 200 || result.status === 201) {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Success("New Sticker Size successfully added");
          this.setState(({
            length: null,
            width: null,
            shapeid: null,
            stickerSizeId: null
          }))
          this.componentDidMount();
        } else {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Failure(
            "Something went wrong, please try again later"
          );
        }
      })
    );
  };

  handleInputChange = (e) => {
    this.setState({
      fld_Size_name: e.target.value,
    });
  };

  searchBarHandler = (e) => {
    this.setState({
      searchInput: e.target.value,
    });
  };

  photoUpload = (e) => {
    e.preventDefault();
    const imageFile = e.target.files[0];
    this.setState({
      imagePreviewUrl: URL.createObjectURL(imageFile),
      originalImage: imageFile,
      outputFileName: imageFile.name,
      uploadImage: true
    });
  };


  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}

            <div className="row">
              <div className="col-md-6">

                <div>
                  <ul class="breadcrumbs">
                    <li><a href="https://store.bechofy.in/">store.bechofy.in</a></li>
                    <li>Master Management</li>
                    <li>Sticker Size</li>
                  </ul>
                </div>
              </div>
              <div className="col-md-6">
                {/* <img src={GtLogo} alt="company logo" className="img-responsive companyLogo"></img> */}

              </div>


            </div>
            <Row>
              <Col xl="12">
                <Card className="pagebackground" id="upload-card">


                  <Card >
                    <div className="Bechofy-bg-soft-pink" style={{ height: '60px' }}>
                      <div className="row my-1">
                        <div className="col-4">
                          <div className="form-group">
                            <h4 className="FilterCard" style={{ marginTop: '10px' }}>Sticker Sizes</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <CardBody className="pt-0">
                      <Row>


                        <MDBCol md="12" style={{ marginBottom: "15px", marginTop: '15px' }} >
                          <div class="input-group mb-3" >


                            <div class="input-group-prepend">
                              <span class="input-group-text" id="basic-addon1">
                                <span className=""><img src={Searchicon} alt="block user" className="btnicons"></img></span></span>
                            </div>
                            <input type="text" class="form-control" placeholder="Type the search phrase you wish to search within the grid" aria-label="Search" aria-describedby="basic-addon1"
                              onChange={(e) => this.seachBarHandler(e)}
                              value={this.state.searchInput}

                            />
                          </div>
                        </MDBCol>

                        <Col md="12">

                          {this.state.stickerSizeData.length !== 0 ?
                            <Card >

                              <CardBody className="pt-0">
                                <Row>
                                  <Col xs="4">
                                    <CardBody className="categoryCard">
                                      <Row className="card-row">
                                        <Col sm="12">
                                          <h5>Add New Size For {localStorage.getItem("stickerNameForSize")}</h5>
                                        </Col>
                                      </Row>
                                      <Row className="card-row">
                                        <Col sm="6">
                                          <div className="row">

                                            <div className="col-12">
                                              <label class="my-1 mr-2">Length *</label>

                                              <input
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                placeholder="Enter Length"
                                                value={this.state.length}
                                                onChange={(text) => {
                                                  this.setState({
                                                    length: text.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                            <div className="col-12">
                                              <label class="my-1 mr-2">Width *</label>

                                              <input
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                placeholder="Enter Width"
                                                value={this.state.width}
                                                onChange={(text) => {
                                                  this.setState({
                                                    width: text.target.value,
                                                  });
                                                }}
                                              />

                                            </div>
                                            <div className="col-12">
                                              <label class="my-1 mr-2">Sequence *</label>

                                              <input
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                placeholder="Seq"
                                                value={this.state.sequence}
                                                onChange={(text) => {
                                                  this.setState({
                                                    sequence: text.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                            <div className="col-12" style={{ marginTop: '10px' }}>
                                              <div className="form-group">
                                                <label for="CategoryName">
                                                  Status
                                                  <span className="mandatory">*</span>
                                                </label>
                                                <br />
                                                <label class="radio-inline">
                                                  <input
                                                    type="radio"
                                                    name="optradio"
                                                    //  disabled={!this.state.IsVisible}
                                                    checked={
                                                      this.state.Status == "Yes"
                                                        ? true
                                                        : false
                                                    }

                                                    onChange={() => {
                                                      this.setState({
                                                        Status: "Yes",
                                                      });
                                                    }}
                                                  />{" "}
                                                  Active
                                                </label>
                                                <label
                                                  class="radio-inline"
                                                  style={{ marginLeft: "10px" }}
                                                >
                                                  <input
                                                    type="radio"
                                                    name="optradio"
                                                    //  disabled={!this.state.IsVisible}
                                                    checked={
                                                      this.state.Status == "No"
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={() => {
                                                      this.setState({
                                                        Status: "No",
                                                      });
                                                    }}
                                                  />{" "}
                                                  Inactive
                                                </label>
                                              </div>
                                            </div>

                                          </div>
                                        </Col>
                                        <hr />
                                      </Row>
                                      <Row>
                                        <Col sm="6">
                                        </Col>
                                        <Col sm="6">

                                          <a
                                            onClick={this.onSaveData.bind(this)}
                                            className="btn Bechofy-btn waves-effect waves-light btn-sm float-right"
                                            style={{ marginTop: "5px", color: "white" }}
                                          >
                                            <span className=""><img src={Saveicon} alt="block user" className="btnicons" style={{ marginRight: '5px' }}></img> </span>

                                            Save Size
                                          </a>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Col>


                                  {/* ======Brand List */}
                                  {this.state.stickerSizeData.filter((data) => {
                                    if (this.state.searchInput == "") {
                                      return data;
                                    }
                                    if (
                                      this.state.searchInput !== "" &&
                                      (data.fld_SizeName
                                        .toLowerCase()
                                        .includes(this.state.searchInput.toLowerCase()) ||

                                        `${data.fld_status
                                          ? data.fld_status.toLowerCase()
                                          : ""
                                          }`.includes(this.state.searchInput.toLowerCase()))
                                    ) {
                                      return data;
                                    }
                                  }).map((data, i) => (
                                    <Col xs="4">
                                      <CardBody className="categoryCard">

                                        <Row className="card-row">
                                          <Col sm="7">
                                            <div className="row">
                                              <div className="col-12" style={{ marginTop: '10px' }}>
                                                <p>
                                                  <b>Length</b> -{" "}
                                                  <span>
                                                    {data.fld_length}
                                                  </span>
                                                </p>

                                              </div>
                                            </div>
                                            <div className="row">
                                              <div className="col-12" style={{ marginTop: '10px' }}>
                                                <p>
                                                  <b>Width</b> -{" "}
                                                  <span>
                                                    {data.fld_width}
                                                  </span>
                                                </p>

                                              </div>
                                            </div>
                                            <div className="row">
                                              <div className="col-12" style={{ marginTop: '10px' }}>
                                                <p>
                                                  <b>Sequence</b> -{" "}
                                                  <span>
                                                    {data.fld_sequence}
                                                  </span>
                                                </p>

                                              </div>
                                            </div>
                                          </Col>
                                          <hr />
                                        </Row>
                                        <Row>
                                          <Col sm="4" className="BrandStatus">
                                            <p >
                                              <b>Status</b> -{" "}
                                              <span
                                                style={{
                                                  color:
                                                    data.fld_status == "Active" || data.fld_status == "Yes"
                                                      ? "green"
                                                      : "red",
                                                }}
                                              >
                                                {data.fld_status}
                                              </span>
                                            </p>
                                          </Col>
                                          <Col sm="8">
                                            <span>
                                              <a
                                                onClick={() => {
                                                  this.setState({
                                                    stickerSizeId: data.fld_size_id,
                                                    length: data.fld_length,
                                                    width: data.fld_width,
                                                    Status: data.fld_status,
                                                    sequence: data.fld_sequence
                                                  })
                                                  window.location.href = "#upload-card"

                                                }}
                                                // onClick={this.onSaveData.bind(this)}
                                                className="btn Bechofy-btn waves-effect waves-light btn-sm float-right"
                                                style={{ marginTop: "5px", color: "white" }}
                                              >
                                                <span className=""><img src={Editicon} alt="block user" className="btnicons" style={{ marginRight: '5px' }}></img> </span>

                                                Edit
                                              </a>
                                            </span>

                                          </Col>
                                        </Row>
                                      </CardBody>
                                    </Col>
                                  ))}
                                </Row>
                              </CardBody>
                            </Card>
                            :
                            <Card >

                              <CardBody className="pt-0">
                                <Row>
                                  <Col xs="4">
                                    <CardBody className="categoryCard">
                                      <Row className="card-row">
                                        <Col sm="12">
                                          <h5>Add New Size For {localStorage.getItem("ShapeNameForEdit")}</h5>
                                        </Col>
                                      </Row>
                                      <Row className="card-row">
                                        <Col sm="6">
                                          <div className="row">

                                            <div className="col-12">
                                              <label class="my-1 mr-2">Length *</label>

                                              <input
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                placeholder="Enter Length"
                                                value={this.state.length}
                                                onChange={(text) => {
                                                  this.setState({
                                                    length: text.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                            <div className="col-12">
                                              <label class="my-1 mr-2">Width *</label>

                                              <input
                                                className="form-control"
                                                name="name"
                                                type="text"
                                                placeholder="Enter Width"
                                                value={this.state.width}
                                                onChange={(text) => {
                                                  this.setState({
                                                    width: text.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                            <div className="col-12" style={{ marginTop: '10px' }}>
                                              <div className="form-group">
                                                <label for="CategoryName">
                                                  Status
                                                  <span className="mandatory">*</span>
                                                </label>
                                                <br />
                                                <label class="radio-inline">
                                                  <input
                                                    type="radio"
                                                    name="optradio"
                                                    //  disabled={!this.state.IsVisible}
                                                    checked={
                                                      this.state.Status == "Yes"
                                                        ? true
                                                        : false
                                                    }

                                                    onChange={() => {
                                                      this.setState({
                                                        Status: "Yes",
                                                      });
                                                    }}
                                                  />{" "}
                                                  Active
                                                </label>
                                                <label
                                                  class="radio-inline"
                                                  style={{ marginLeft: "10px" }}
                                                >
                                                  <input
                                                    type="radio"
                                                    name="optradio"
                                                    //  disabled={!this.state.IsVisible}
                                                    checked={
                                                      this.state.Status == "No"
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={() => {
                                                      this.setState({
                                                        Status: "No",
                                                      });
                                                    }}
                                                  />{" "}
                                                  Inactive
                                                </label>
                                              </div>
                                            </div>

                                          </div>
                                        </Col>
                                        <hr />
                                      </Row>
                                      <Row>
                                        <Col sm="6">
                                        </Col>
                                        <Col sm="6">

                                          <a
                                            onClick={this.onSaveData.bind(this)}
                                            className="btn Bechofy-btn waves-effect waves-light btn-sm float-right"
                                            style={{ marginTop: "5px", color: "white" }}
                                          >
                                            <span className=""><img src={Saveicon} alt="block user" className="btnicons" style={{ marginRight: '5px' }}></img> </span>

                                            Save Size
                                          </a>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          }
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Card>

                {/* <WelcomeComp /> */}
              </Col>
            </Row>
            {/* </Card>

							</Col>
						</Row> */}
          </Container>
        </div >
      </React.Fragment >
    );
  }
}

export default StickerSizeMaster;
